// Google Preferred Source scroll popup (SCWEB-5039) and click tracking (SCWEB-5067).
//
// Reveals the Preferred Source button on a blog post once the reader has scrolled 75% of
// the page. Vanilla JS on purpose: this is emitted mid-body by the rendering partial, and
// not depending on jQuery load order keeps it safe wherever it lands.
//
// Two conditions must both hold before the popup appears:
//   1. the reader has passed the scroll threshold, and
//   2. Google has actually rendered the button.
// Google renders into a shadow root and sets data-initialized="true" on the host once it
// has done so. Without check 2 the popup could open as an empty box for visitors who
// declined cookie consent (Klaro never activates publisher.js) or on a domain Google does
// not recognise as a source.
(function () {
    'use strict';

    var DISMISS_COOKIE = 'preferredSourceDismissed';
    var DISMISS_DAYS = 180;
    var SCROLL_THRESHOLD = 0.75;

    function getCookie(name) {
        var parts = document.cookie.split(';');
        for (var i = 0; i < parts.length; i++) {
            var pair = parts[i].trim();
            if (pair.indexOf(name + '=') === 0) {
                return decodeURIComponent(pair.substring(name.length + 1));
            }
        }
        return '';
    }

    function setCookie(name, value, days) {
        var date = new Date();
        date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
        document.cookie = name + '=' + encodeURIComponent(value) +
            '; expires=' + date.toUTCString() + '; path=/';
    }

    // Pushes a GTM-friendly event when the visitor clicks the Preferred Source button. The
    // button Google renders has no usable click element for a GTM click trigger, so GTM
    // listens for this custom event instead. Delegated from document, and independent of
    // init(), so it covers the footer placement, a dismissed popup, and a button Google
    // re-renders. Events from Google's shadow root are retargeted to the host element, which
    // is what closest() matches.
    function trackClicks() {
        // Blog posts render both placements, so this script can be included twice.
        if (window.__preferredSourceTracking) {
            return;
        }
        window.__preferredSourceTracking = true;

        document.addEventListener('click', function (event) {
            var target = event.target;
            var host = target && target.closest && target.closest('[google-add-preferred-source-btn]');
            if (!host) {
                return;
            }
            var wrapper = host.closest('[data-preferred-source-placement]');
            (window.dataLayer = window.dataLayer || []).push({
                event: 'preferred_source_button_click',
                placement: wrapper ? wrapper.getAttribute('data-preferred-source-placement') : 'unknown'
            });
        });
    }

    function init() {
        var popup = document.querySelector('[data-preferred-source-popup]');
        if (!popup) {
            return;
        }

        // Respect a previous dismissal before doing any work.
        if (getCookie(DISMISS_COOKIE)) {
            return;
        }

        var button = popup.querySelector('[google-add-preferred-source-btn]');
        var dismiss = popup.querySelector('[data-preferred-source-dismiss]');
        var observer = null;
        var ticking = false;
        var shown = false;
        var pageLoaded = false;

        // Returns scroll progress 0..1, or -1 when the document is not scrollable.
        function scrollProgress() {
            var doc = document.documentElement;
            var max = doc.scrollHeight - window.innerHeight;
            if (max <= 0) {
                return -1;
            }
            return (window.pageYOffset || doc.scrollTop) / max;
        }

        function thresholdMet() {
            var progress = scrollProgress();
            if (progress < 0) {
                // Not scrollable. That is only meaningful once images have loaded and
                // layout has settled - this script runs deferred, well before that, when
                // scrollHeight still reports roughly the viewport height. Treating that as
                // "fully read" would pop the panel open instantly at the top of the page.
                return pageLoaded;
            }
            return progress >= SCROLL_THRESHOLD;
        }

        function buttonRendered() {
            return !!button && button.getAttribute('data-initialized') === 'true';
        }

        function onKeyDown(event) {
            if (event.key === 'Escape' || event.keyCode === 27) {
                hide();
            }
        }

        function hide() {
            popup.classList.remove('is-visible');
            popup.setAttribute('hidden', '');
            document.removeEventListener('keydown', onKeyDown);
            // Only written once the reader actually dismisses, so a visitor who never sees
            // the popup is never given a cookie for it.
            setCookie(DISMISS_COOKIE, '1', DISMISS_DAYS);
        }

        function show() {
            shown = true;
            stopListening();
            popup.removeAttribute('hidden');
            // Next frame, so the element is laid out before the transition starts.
            window.requestAnimationFrame(function () {
                popup.classList.add('is-visible');
            });
            document.addEventListener('keydown', onKeyDown);
        }

        function maybeShow() {
            if (shown || !thresholdMet() || !buttonRendered()) {
                return;
            }
            show();
        }

        function onScroll() {
            if (ticking) {
                return;
            }
            ticking = true;
            window.requestAnimationFrame(function () {
                ticking = false;
                maybeShow();
            });
        }

        function stopListening() {
            window.removeEventListener('scroll', onScroll);
            window.removeEventListener('load', onLoad);
            if (observer) {
                observer.disconnect();
                observer = null;
            }
        }

        function onLoad() {
            pageLoaded = true;
            // Covers a post short enough that it never becomes scrollable.
            maybeShow();
        }

        if (dismiss) {
            dismiss.addEventListener('click', hide);
        }

        // publisher.js loads asynchronously and only after consent, so the button may well
        // initialize after the reader has already passed the threshold. Without this the
        // popup would never appear for anyone who stopped scrolling at that point.
        if (button && window.MutationObserver) {
            observer = new MutationObserver(maybeShow);
            observer.observe(button, { attributes: true, attributeFilter: ['data-initialized'] });
        }

        window.addEventListener('scroll', onScroll, { passive: true });

        if (document.readyState === 'complete') {
            onLoad();
        } else {
            window.addEventListener('load', onLoad);
        }

        // Covers a reader returning to a page already scrolled past the threshold.
        maybeShow();
    }

    trackClicks();

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', init);
    } else {
        init();
    }
})();
